import { unflatten } from 'flat'
import { merge, memoize } from 'lodash'

export function PrefixedElementDatasetConfig (
  prefix,
  element,
  defaultConfig = {}
) {
  if (!element) return {}
  if (!prefix) return {}
  const dataset = ConfigValueParser({ ...element.dataset })
  const filtered = FilteredPrefixedConfigParser(prefix, dataset)
  const config = ConfigMerger(
    filtered,
    defaultConfig
  )
  return config
}

export function ElementDatasetConfig (
  element,
  defaultConfig = {}
) {
  if (!element) return {}
  const dataset = ConfigValueParser({ ...element.dataset })
  const config = ConfigMerger(
    dataset,
    defaultConfig
  )
  return config
}

export function ComputeQuerystring (
  querystring = window.location.search
) {
  const dataset = querystring
    .replace(/^\??/, '')
    .split('&')
    .reduce((result, item) => {
      if (item.includes('=')) {
        const [key, value] = item.split('=')
        return {
          ...result,
          [key]: value
        }
      } else {
        return {
          ...result,
          [item]: true
        }
      }
    }, {})
  return dataset
}

export const ComputedMemoizedQuerystring = memoize(ComputeQuerystring)

export function QuerystringConfig (
  querystring,
  defaultConfig = {}
) {
  if (!querystring) return {}

  const data = ComputedMemoizedQuerystring(querystring)
  const config = ConfigMerger(
    ConfigValueParser(data),
    defaultConfig
  )
  return config
}

export function PrefixedQuerystringConfig (
  prefix,
  querystring,
  defaultConfig = {}
) {
  if (!prefix) return {}
  if (!querystring) return {}

  const dataset = ComputedMemoizedQuerystring(querystring)
  const data = FilteredPrefixedConfigParser(prefix, dataset)
  const config = ConfigMerger(
    ConfigValueParser(data),
    defaultConfig
  )
  return config
}

export function FilteredPrefixedConfigParser (
  prefix,
  dataset
) {
  const prefixReplacePattern = new RegExp(`^${prefix}_?`)
  return Object.keys(dataset)
    .filter(key => key.startsWith(prefix) && key !== prefix)
    .reduce((result, key) => {
      const newKey = key.replace(prefixReplacePattern, '')
      return {
        ...result,
        [newKey]: dataset[key]
      }
    }, {})
}

export function ConfigValueParser (
  config
) {
  const parse = (value) => {
    try {
      return JSON.parse(value)
    } catch (err) {
      // Disable noisy logs, 99% of the time these params arent meant to be JSON
      // console.log(`Problem parsing ${value}`, err)
    }
    return value
  }

  return Object.keys(config)
    .reduce((result, key) => {
      if (!config[key]) {
        return result
      }

      return {
        ...result,
        [key]: parse(config[key])
      }
    }, {})
}

export function ConfigMerger (
  config,
  defaultConfig = {}
) {
  const processed = unflatten(config, {
    delimiter: '__',
    overwrite: true
  })
  const output = merge({}, defaultConfig, processed)
  return output
}
